/**
 *
 * Asynchronously loads the component for UpdateStorePage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UpdateStorePage = lazyLoad(
  () => import('./index'),
  module => module.UpdateStorePage,
);
